import { FC } from 'react'
import { Link } from 'react-router-dom'

import { Divider } from '@/components/Divider'
import ClockIcon from '@/components/icons/clock.svg?react'
import CostIcon from '@/components/icons/cost.svg?react'
import PackageIcon from '@/components/icons/package.svg?react'
import SuccessIcon from '@/components/icons/success.svg?react'
import { Button } from '@/components/ui/button'
import { RoutePath } from '@/RoutePath'

interface UniteSuccessDialogProps {
  onClose: () => void
  packageCount: number
  totalCost: number
}

export const UniteSuccessDialog: FC<UniteSuccessDialogProps> = ({ onClose, packageCount, totalCost }) => {
  return (
    <div className='flex flex-col items-center gap-4 bg-white'>
      {/* Success Icon */}
      <div className='h-6 w-6'>
        <SuccessIcon className='text-icon-primary h-full w-full' />
      </div>

      {/* Title and Description */}
      <div className='flex flex-col items-center gap-4'>
        <h2 className='text-text-primary text-center text-base font-medium'>החבילות שלך מתאחדות!</h2>
        <p className='text-text-secondary text-center text-sm'>נעדכן אותך כשהתהליך יושלם והחבילה תהיה מוכנה למשלוח!</p>
      </div>

      {/* Info Container */}
      <div className='bg-button-primary-selected-segment w-full rounded-lg p-4'>
        <div className='flex flex-col gap-2'>
          {/* Cost Info */}
          <div className='flex items-center gap-2'>
            <CostIcon className='size-4' />
            <span className='text-text-secondary text-sm'>עלות האיחוד: ${totalCost}</span>
          </div>

          {/* Package Count */}
          <div className='flex items-center gap-2'>
            <PackageIcon className='text-text-secondary size-4' />
            <span className='text-text-secondary text-sm'>מספר חבילות מאוחדות: {packageCount}</span>
          </div>

          {/* Time Info */}
          <div className='flex items-center gap-2'>
            <ClockIcon className='text-text-secondary size-4' />
            <span className='text-text-secondary text-sm'>תהליך האיחוד יארך 2–3 ימי עסקים</span>
          </div>
        </div>
      </div>
      <Divider />
      <Link to={RoutePath.ClientPkg}>
        <Button size='sm' variant='ghost' onClick={onClose} className='text-text-secondary text-sm'>
          חזור לחבילות שלי
        </Button>
      </Link>
    </div>
  )
}
